/* eslint-disable @angular-eslint/component-selector */

import { Component, Input, OnInit } from '@angular/core';
import { Audit } from 'app/core/models/audit.model';
import { obj2Html } from '../../../core/lib/js-utils';
import { DatePipe } from '@angular/common';
import { BlankValueDashPipe } from '../../../shared/pipes/blank-value-dash.pipe';
import { keyedProviderDataReviewTypeOptions } from 'app/core/options/provider-data-review-type.opts';

@Component({
    selector: '[app-audit-provider-data-review-create-row]',
    templateUrl: './audit-provider-data-review-create-row.component.html',
    styleUrls: ['./audit-provider-data-review-create-row.component.scss'],
    imports: [DatePipe, BlankValueDashPipe]
})
export class AuditProviderDataReviewCreateRowComponent implements OnInit {
  @Input() audit: Audit;
  newValueHtml;

  keyedProviderDataReviewTypeOptions = keyedProviderDataReviewTypeOptions;

  constructor() {}

  ngOnInit() {
    const {
      ...changes
    } = this.audit.auditedChanges;

    this.newValueHtml = obj2Html(changes);
  }
}
